import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar.js";
import logo from "../assets/images/logo.svg";
import {
    Button,
} from "@mui/material";
import isEmpty from "is-empty";
import { ResetPasswordvalidation } from "./validation.js";
import { toastAlert } from "../helper/toastAlert.jsx";
import { ResetPasswordAction, getAdminDetailsAction } from "../Action/ApiAction.js";
import { getAuthToken } from "../helper/localstorage.js";
import { useHistory, useParams } from "react-router-dom";
import {getUrlList} from "../Action/UserAction"
import config from "../config/config"
import clsx from "classnames";
// Scroll to Top
function ScrollToTopOnMount() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return null;
}
const initialFormValue = {
    'password': '',
    'confirmPassword': '',
    'showNewpassword':false,
    'showconfirmpassword':false
}
export default function ResetPassword() {
    const history = useHistory()
    const { userId } = useParams();
    // state
    const [formValue, setFormValue] = useState(initialFormValue);
    const [validateError, setValidateError] = useState({});
    const [logodata, setLogodata] = useState();
    const { password, confirmPassword,showNewpassword,showconfirmpassword} = formValue;
    const handleChange = (e) => {
        e.preventDefault();
        const { name, value } = e.target;
        let formData = { ...formValue, ...{ [name]: value } }
        setFormValue(formData)
        if (!isEmpty(validateError)) {
            setValidateError({})
        }
    }
    useEffect(() => {
        getAdminDetails();
    }, []);

    const getAdminDetails = async () => {
        let data = {
            randomno: userId,
        };
        const { result } = await getAdminDetailsAction(data);
        if (result) {
            if (result.activeDatas == "Active") {
                toastAlert("error", "You already used this Link");
                history.push("/login");
            } else {
            }
        }
    };
    const handleFormSubmit = async (e) => {
        e.preventDefault();
        var token = getAuthToken()
        let reqData = {
            password: password,
            confirmPassword: confirmPassword,
            userId: userId,
        }
        let validationError = ResetPasswordvalidation(reqData)
        if (!isEmpty(validationError)) {
            setValidateError(validationError)
            return
        }
        try {
            let { status, errors } = await ResetPasswordAction(reqData);
            if (status == true) {
                setFormValue(initialFormValue)
                history.push('/dashboard')
                toastAlert('success', 'Password changed successfully');
            } else {
                if (errors) {
                    setValidateError(errors);
                    toastAlert('error', errors, 'link');
                }
            }
        }
        catch (err) {
            console.log('err222: ', err);
        }
    }
    async function getLogo() {
   
        var response = await getUrlList()
        var list1 = response && response.result ? response.result : {}
        setLogodata(list1)
        console.log(list1,'logodata')
      }
      useEffect(() => {
        getLogo()
        
      }, [])
    return (
        <>
            <ScrollToTopOnMount />
            <div className="apppage_wrapper">
                <div className="app_page">
                   
                    <div className="page_wrapper">
                        <div className="page_content">
                            <div className="container-fluid">
                                <div className="row py-3">
                                    <h2 className="page_title">Reset Password</h2>
                                    <div className="col-md-8 col-lg-6 col-xl-5 m-auto">
                                        <div className="dashbox_inner">
                                            <div className="change_password_panel">
                                                {/* <img src={logo} alt="Logo" className="img-fluid" /> */}
                                                {logodata && logodata.logoURI && <img src={`${
                      config.imageUrl+'/logo/'+logodata.logoURI
                      }`} alt="Logo" className="img-fluid" />}
                                                <h3>Password Help</h3>
                                                <div className="form-group">
                                                    <label>New password</label>
                                                    <div class="password-container">
                                                    <input className="form-control" type={showNewpassword ? "text" : "password"} name="password"
                                                        value={password}
                                                        onChange={handleChange} />
                                                         <a
              onClick={(e) => {
                e.preventDefault();
                setFormValue((el) => {
                  return { ...el, ...{ showNewpassword: !el.showNewpassword } };
                });
              }}
              class="toggle-password"
            >
                             <i
                className={clsx(
                  "fa",
                  { "fa-eye": showNewpassword },
                  { "fa-eye-slash": !showNewpassword }
                )}
                aria-hidden="true"
              ></i>

              </a>
              </div>
                                                    {
                                                        validateError.password && <p className="error-message" style={{ color: "red" }}>{validateError.password}</p>
                                                    }
                                                </div>
                                                <div className="form-group">
                                                    <label>Confirm New password</label>
                                                    <div class="password-container">
                                                    <input className="form-control" type={showconfirmpassword ? "text" : "password"} name="confirmPassword"
                                                        value={confirmPassword}
                                                        onChange={handleChange} />
                                                               <a
              onClick={(e) => {
                e.preventDefault();
                setFormValue((el) => {
                  return { ...el, ...{ showconfirmpassword: !el.showconfirmpassword } };
                });
              }}
              class="toggle-password"
            >
                             <i
                className={clsx(
                  "fa",
                  { "fa-eye": showconfirmpassword },
                  { "fa-eye-slash": !showconfirmpassword }
                )}
                aria-hidden="true"
              ></i>
              </a>
              </div>
                                                    {
                                                        validateError.confirmPassword && <p className="error-message" style={{ color: "red" }}>{validateError.confirmPassword}</p>
                                                    }
                                                </div>
                                                <div className="text-center">
                                                    <Button variant="contained" onClick={handleFormSubmit}>Submit</Button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}